export const EDIT_PERMISSION_LABELS = {
  codigo: "Código",
  nome: "Nome",
  descricao: "Descrição",
} as const;

/** MS002 — apresentada ao posicionar o cursor sobre o campo Código desabilitado (Figma 5340:105382). */
export const CODE_LOCKED_MESSAGE = "Não é possível editar o código da permissão.";

/** Limites da tabela `plataforma.permissao`. */
export const NAME_MAX_LENGTH = 150;
export const DESCRIPTION_MAX_LENGTH = 500;
export const DESCRIPTION_ROWS = 4;

export const EDIT_PERMISSION_TITLE = "Editar permissão";

/** Liga o botão Salvar, que vive no rodapé do Dialog, ao formulário do corpo. */
export const EDIT_PERMISSION_FORM_ID = "edit-permission-form";
export const CODE_FIELD_ID = "edit-permission-code-field";
